// eslint-disable-next-line import/extensions
import OrderListPage from './OrderListPage.container.jsx'

export default OrderListPage
